import { IAppState } from 'src/store/types';

export const getTableApiRef = (state: IAppState) => state.table.apiRef;
export const getTableRows = (state: IAppState) => state.table.rows;
export const getTableColumns = (state: IAppState) => state.table.columns;
